<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneTalk_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M7.119 1.67a.46.46 0 0 1 .357-.546 5.954 5.954 0 0 1 5.214 1.42 5.951 5.951 0 0 1 1.888 5.062.46.46 0 1 1-.916-.105 5.023 5.023 0 0 0-1.594-4.277 5.025 5.025 0 0 0-4.404-1.197.46.46 0 0 1-.545-.357ZM12.61 13.08c-.388.69-1.144 1.174-2.023 1.296-1.689.235-3.858-.802-6.306-3.249C1.289 8.136.863 6.047 1.03 4.821c.122-.878.606-1.634 1.297-2.022a1.15 1.15 0 0 1 1.559.413l1.316 2.192a1.156 1.156 0 0 1-.174 1.415l-.617.634c.456.741.974 1.369 1.574 1.968.6.6 1.228 1.118 1.92 1.585l.687-.632a1.152 1.152 0 0 1 1.41-.17l2.193 1.315c.54.325.723 1.01.414 1.56Z"
    />
    <path
        fill="currentColor"
        d="M7.388 3.785a.461.461 0 1 0 .353.853 2.493 2.493 0 0 1 2.625.451c.705.643.974 1.653.69 2.573a.461.461 0 0 0 .88.274 3.417 3.417 0 0 0-.948-3.528 3.418 3.418 0 0 0-3.6-.623Z"
    />
</svg>
